var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row h-screen flex-wrap"},[_c('TopBar'),_c('LeftBar'),_c('Container',{staticClass:"relative"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }